var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTable = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M15.092 3.141H2.908a.5.5 0 0 0-.5.5V14.39a.5.5 0 0 0 .5.5h12.184a.5.5 0 0 0 .5-.5V3.64a.5.5 0 0 0-.5-.5ZM9 3.141V14.89m6.592-7.77H2.408m13.184 3.76H2.408" }) }))); };
export default SvgTable;
